module.exports = __webpack_public_path__ + "img/super03.ed4f1341.png";